<template>
  <vue-tel-input
    v-model="value"
    :class="$style.inputWrap"
    :allCountries="countries"
    mode="international"
    :defaultCountry="company.country?.toUpperCase() || 'NL'"
    :dropdownOptions="{
      showSearchBox: true,
      showDialCodeInList: true,
      showFlags: true
    }"
    :inputOptions="{
      required: !!required,
      placeholder: ''
    }"
    validCharactersOnly
  />
</template>

<script setup lang="ts">
import { useCompanyStore } from '@/stores/company';
import 'vue-tel-input/vue-tel-input.css';
import phonePrefixes from './phone-prefixes';
import i18n from '@/i18n';
import { computed } from 'vue';
const props = defineProps<{
  modelValue: string;
  required?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  }
});

const { company } = useCompanyStore();

const regionNames = new Intl.DisplayNames([i18n.locale.value], {
  type: 'region'
});

const countries = phonePrefixes.map((item) => ({
  name: regionNames.of(item.code.toUpperCase()),
  iso2: item.code.toUpperCase(),
  dialCode: item.prefix.toString()
}));
</script>

<style lang="scss" module>
.inputWrap {
  box-shadow: none !important;

  :global(.vti__dropdown-arrow) {
    width: 8px;
  }

  :global(.vti__dropdown-list) {
    border-radius: 8px;
    border-color: $color-border-input;
    max-width: 310px;

    input {
      margin: $spacing * 0.5;
      width: calc(100% - #{$spacing});
    }
  }
}
</style>
